import { render, staticRenderFns } from "./KpiWidget.vue?vue&type=template&id=b07929f2"
import script from "./KpiWidget.vue?vue&type=script&lang=ts"
export * from "./KpiWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports